/*
 * File: /src/services/groupServices.js
 * Created Date: Friday June 14th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Friday, 14th June 2019 9:55:39 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
import { AD_BASE_GROUPS_PATH } from '../constants';
import { authedAxios } from '../shared/axiosWrapper';

export default {
  /**
   * Get Config
   *
   * @returns
   */
  getConditionConfig() {
    return authedAxios.get(AD_BASE_GROUPS_PATH + 'condition-config');
  }
};
